// Jquery Only for trikot products

$(document).ready(function () { 
     
    if(window.aico_percentage_discount && window.aico_percentage_discount!=0){
      const main_price_el = $(".active-product").find(".product_trikot_price_wrap .tprice_main .tprice_main_amount");
      var main_price = parseFloat(main_price_el.attr('data-amount'));
      var main_compare_price = parseFloat(main_price_el.attr('data-compare-amount'));
      let discountPrice;
      let originalPrice = main_price;
      
      // If compare_at_price exists, calculate discount from compare_at_price
      if(main_compare_price && !isNaN(main_compare_price) && main_compare_price > 0) {
        let compareDiscountPrice = applyAicoDiscount(main_compare_price);
        
        // Give customer maximum discount - use the lower price
        if(compareDiscountPrice < main_price) {
          // Discounted price is better for customer
          discountPrice = compareDiscountPrice;
          originalPrice = main_compare_price; // Show compare_at_price as strikethrough
        } else {
          // Current price is better for customer
          discountPrice = main_price;
          originalPrice = main_compare_price; // Show compare_at_price as strikethrough
        }
      } else {
        // No compare_at_price, calculate discount from current price
        discountPrice = applyAicoDiscount(main_price);
        originalPrice = main_price;
      }
      
      // Update the element with discounted price
      main_price_el.text(discountPrice);
      main_price_el.attr('data-amount', discountPrice);
      main_price_el.attr('data-main-amount', originalPrice);
       
    }

  $(document).on('click','.trikots-tabs:not(.badges-tabs) .tab',function(){ 
    const $activeProduct = $(this).closest(".active-product");
    $activeProduct.find(".trikots-tabs:not(.badges-tabs) .tab").removeClass("active"); 
    $(this).addClass("active");
    let tabValue = $(this).attr("data-tab");
    let pro_type = 'Flock';

    // Display delivery not based on badge type
    let active_badge_tab = $activeProduct.find('.trikots-tabs.badges-tabs .tab.active').attr("data-tab");
    var flag = 0;
    if(tabValue != 'Ohne'){
      flag++;
    }
    if(active_badge_tab != 'Ohne Badge' && typeof active_badge_tab != 'undefined'){
      flag++;
    }
    
    if(flag == 0){
      $(this).parents('.product__info-wrapper').find('.stock_wrap').children('.delivery_note.normal_product').removeClass('hidden');
      $(this).parents('.product__info-wrapper').find('.stock_wrap').children('.delivery_note.trikot_product').addClass('hidden');
    }else{
      $(this).parents('.product__info-wrapper').find('.stock_wrap').children('.delivery_note.normal_product').addClass('hidden');
      $(this).parents('.product__info-wrapper').find('.stock_wrap').children('.delivery_note.trikot_product').removeClass('hidden');
    }    
    
    let product_form__error_message_wrapper = $activeProduct.find('.product-form__error-message-wrapper');
    let product_form__error_message = $activeProduct.find('.product-form__error-message');
    product_form__error_message_wrapper.attr("hidden",true);
    product_form__error_message.text('');   
    
    $activeProduct.find(".trikots-contents:not(.badges-contents) .hidden_product_input").removeClass("active"); 
    $activeProduct.find('.trikots-contents .hidden_product_input[data-content="' + tabValue + '"]').addClass("active"); // Show the matching content    
    
    if(tabValue == 'spieler' || tabValue == 'individuell'){ 
      
    }
    else {      

       $activeProduct.find('.individuell-nummer').val('');
       $activeProduct.find(".individuell-name").val('');
       $activeProduct.find('.individuell-nummer-text').val('');
       $activeProduct.find(".individuell-name-text").val('');
       $activeProduct.find('.individual_options .individual_list li').removeClass('active');
       $activeProduct.find(".hidden_product_input[data-content='individuell'] input[type='checkbox']").prop("checked", false);
       $activeProduct.find(".hidden_product_input[data-content='individuell-name'] input[type='checkbox']").prop("checked", false);
      

       $activeProduct.find(".pro_spieler_name").text('');
       $activeProduct.find(".pro_spieler_no").text('');
       $activeProduct.find('.spieler-nummer').val('');
       $activeProduct.find(".spieler-name").val('');
       $activeProduct.find('.custom-dropdown-main-wrap .custom-dropdown-list li').removeClass('active');
       $activeProduct.find('.hidden_product_input[data-content="spieler"] .select__select').val('0').change();
       $activeProduct.find('.product-form .properties_flock').val('');
      
       const type_price_item = $activeProduct.find(`.product_trikot_price_wrap .tprice_extra_wrap .hidden-price-item[data-type='${pro_type}']`);
       type_price_item.removeClass('active');
       type_price_item.attr('data-amount','');
       type_price_item.text('');
    }

    if(tabValue == 'spieler'){
       $activeProduct.find('.spieler_dropdown_wrap .custom-dropdown-options').show();
    }
    updateTrikotTotal($(this));
    
  });

  let activeBadges = [];
  $(document).on('click','.badges-tabs .tab',function(){   

    const $activeProduct = $(this).closest(".active-product");
    let tabValue = $(this).attr("data-tab"); 
    let tabName = $(this).attr("data-name");
    let pro_type = 'Badge';
    
    if(tabName){
      $activeProduct.find(".badges-tabs .tab[data-tab='Ohne Badge']").removeClass("active");
      $(this).toggleClass("active");
      const badge_product = $activeProduct.find(".badges-contents .hidden_product_input[data-content='"+ tabValue +"'] input[type='checkbox']");      
      badge_product.prop("checked", function(i, val) {
          return !val;
      });     
      
      const price = badge_product.attr('data-price');
      let amount = badge_product.attr('data-amount');      
      const pro_tag = badge_product.attr('data-tag');   
      const pro_content = badge_product.attr('data-content');
      if(price && pro_content){
         const selected_price_item = $activeProduct.find(`.product_trikot_price_wrap .tprice_extra_wrap .hidden-price-item[data-handle='${pro_content}']`);
         if($(this).hasClass("active")) {            
             if(window.aico_percentage_discount && window.aico_percentage_discount!=0){
              amount = applyAicoDiscount(amount);
             }            
             selected_price_item.text(" + CHF "+ amount);           
             selected_price_item.attr('data-type',pro_type);             
             selected_price_item.attr('data-amount',amount);
             selected_price_item.addClass('active');

             if (!activeBadges.includes(tabName)) {
                activeBadges.push(tabName);
             }
          }
          else {
             selected_price_item.text('');
             selected_price_item.attr('data-type','');
             selected_price_item.attr('data-amount','');
             selected_price_item.removeClass('active');

             activeBadges = activeBadges.filter(item => item !== tabName);
          } 
        } 
        
        $activeProduct.find('.product-form .properties_badges').val(activeBadges.join(', '));        
        if(activeBadges.length == 0){
          $(".badges-tabs .tab[data-tab='Ohne Badge']").addClass("active");
        }
    }
    else {      
      $activeProduct.find(".badges-tabs .tab").removeClass("active"); 
      $(this).addClass("active");
      activeBadges = [];
      $activeProduct.find('.product-form .properties_badges').val('');
      $activeProduct.find(".badges-contents .hidden_product_input input[type='checkbox']").prop("checked", false);      
      const type_price_item = $activeProduct.find(`.product_trikot_price_wrap .tprice_extra_wrap .hidden-price-item[data-type='${pro_type}']`);
      type_price_item.text('');
      type_price_item.attr('data-amount','');
      type_price_item.removeClass('active'); 
    }

    // Display delivery not based on badge type
    let active_trikot_tab = $activeProduct.find(".trikots-tabs:not(.badges-tabs) .tab.active").attr("data-tab");
    var flag = 0;
    if(tabName != 'Ohne Badge' && activeBadges.length > 0){
      flag++
    }
    if(active_trikot_tab != 'Ohne'){
      flag++
    }
    
    if(flag == 0){
      $(this).parents('.product__info-wrapper').find('.stock_wrap').children('.delivery_note.normal_product').removeClass('hidden');
      $(this).parents('.product__info-wrapper').find('.stock_wrap').children('.delivery_note.trikot_product').addClass('hidden');
    }else{
      $(this).parents('.product__info-wrapper').find('.stock_wrap').children('.delivery_note.normal_product').addClass('hidden');
      $(this).parents('.product__info-wrapper').find('.stock_wrap').children('.delivery_note.trikot_product').removeClass('hidden');
    }

    updateTrikotTotal($(this));    
    
  });

  $(document).on("change keyup focusout",".individuell-nummer", function () {
    var $this = $(this);
    var n = $(this).val();
    if (n < 0) {
      $this.parents(".active-product").find(".individuell-nummer").val(0);
    } else if (n > 99) {
      $this.parents(".active-product").find(".individuell-nummer").val(99);
    }
    $this.next('span').find('span').text($(this).val().length);
    $this.parents(".active-product").find(".pro_spieler_no").text(n); 

    individual_option($this);
  });

  $(document).on("change keyup focusout",".individuell-name", function () {
    let $this = $(this);
    let txtInput = $(this).val();
    let txtInput_lower = txtInput.toLowerCase();

    let badWord = "fuck";
    if (txtInput_lower.indexOf(badWord) != -1) {
      let txtInputnew = txtInput_lower.replace(badWord, "");
      $this.parents(".active-product").find(".individuell-name").val(txtInputnew);
      $this.parents(".active-product").find(".pro_spieler_name").text(txtInputnew);
      $this.next('span').find('span').text(txtInputnew.length);
    } else {
      $this.parents(".active-product").find(".individuell-name").val(txtInput);
      $this.parents(".active-product").find(".pro_spieler_name").text(txtInput);
      $this.next('span').find('span').text(txtInput.length)
    }

    individual_option($this);    
  });

  $(document).on('click','.active-product .custom-dropdown-main-wrap .custom-dropdown-selected-wrap', function(){
      $(this).parent().toggleClass('active');
  });

  $(document).on('click','.custom-dropdown-main-wrap .custom-dropdown-list li', function(){
    spilier_option($(this));
    $(this).parents('.custom-dropdown-options').hide();
  });
  
  $(document).on('change','.product-form__input--dropdown .select select', function(){
    var name = $(this).attr("name");
    var index = $(this).attr("option-index");
    var price = $("option:selected", this).attr("data-price");
    var $this = $(this);
    
    var value = $(this).val();
    if (value && value != 0) {
      var arr = [];
      var name = [];

      arr = value.split(" - ");
      name = arr[1].split(" ");
      
      $this.parents(".active-product").find(".pro_spieler_no").text(arr[0]);
      $this.parents(".active-product").find(".pro_spieler_name").text(arr[1].slice(0,14));

      $this.parents(".active-product").find('.individuell-nummer').val('');
      $this.parents(".active-product").find(".individuell-name").val('');
      $this.parents(".active-product").find('.individuell-nummer-text').val('');
      $this.parents(".active-product").find(".individuell-name-text").val('');
      $this.parents(".active-product").find(".hidden_product_input[data-content='individuell'] input[type='checkbox']").prop("checked", false);
      $this.parents(".active-product").find(".hidden_product_input[data-content='individuell-name'] input[type='checkbox']").prop("checked", false);
      $this.parents(".active-product").find('.product-form .properties_flock').val(value);
    }

    let closestProductInfo = $(this).closest('product-info');
    let product_form__error_message_wrapper = $(closestProductInfo).find('.product-form__error-message-wrapper');
    let product_form__error_message = $(closestProductInfo).find('.product-form__error-message');
    product_form__error_message_wrapper.attr("hidden",true);
    product_form__error_message.text('');    
  })
 

  function spilier_option($this){
   $this.parents(".active-product").find('.custom-dropdown-main-wrap .custom-dropdown-list li').removeClass('active');
   $this.addClass('active');
   let price = $this.attr('data-price');
   let amount = $this.attr('data-amount');
   if(window.aico_percentage_discount && window.aico_percentage_discount!=0){
      amount = applyAicoDiscount(amount);
    }  
    price = " + CHF "+amount;   
   
   const pro_tag = $this.parent().attr('data-tag');
   const pro_type = $this.parent().attr('data-type');
   if(price && pro_tag){
     const type_price_item =  $this.parents(".active-product").find(`.product_trikot_price_wrap .tprice_extra_wrap .hidden-price-item.active[data-type='${pro_type}']`);
     if(type_price_item.length > 0){
       type_price_item.text('');
       type_price_item.attr('data-type','');
       type_price_item.attr('data-amount','');
       type_price_item.removeClass('active');
     }
     const selected_price_item =  $this.parents(".active-product").find(`.product_trikot_price_wrap .tprice_extra_wrap .hidden-price-item[data-handle='${pro_tag}']`);
     selected_price_item.text(price);
     selected_price_item.attr('data-type',pro_type);
     selected_price_item.attr('data-amount',amount);
     selected_price_item.addClass('active');
     updateTrikotTotal($this);
   }
   $(settings.objModalCloseBtn).trigger('click');

   let txtInput = $this.attr('data-val');
   if (txtInput) {
      // Split the string by hyphens
      let parts = txtInput.split('-');
      let spieler_nummer = '';
      let spieler_name = '';
     
      if(parts[0]){
        spieler_nummer = parts[0];
        $this.parents(".active-product").find(".spieler-nummer").val(spieler_nummer);
      }
      if(parts[1]){
        spieler_name = parts.slice(1).join('-').trim();
        $this.parents(".active-product").find(".spieler-name").val(spieler_name);
      }             
   }     

   const $select = $this
      .parents('.active-product')        
      .find('.hidden_product_input[data-content="spieler"] select.select__select');
    
    if ($select.find(`option[value="${txtInput}"]`).length) {
      $select.val(txtInput).trigger('change');
    }
  }

  function individual_option($this){
    const $activeProduct = $this.closest(".active-product");     
    let no = $activeProduct.find('.individuell-nummer-text').val();
    let name = $activeProduct.find(".individuell-name-text").val();    
    
    let flag = 0;    
    if(!no && !name){
      flag++;
    }   

    const individuell_no_checkbox = $activeProduct.find(".hidden_product_input[data-content='individuell'] input[type='checkbox']");
    const individuell_name_checkbox = $activeProduct.find(".hidden_product_input[data-content='individuell-name'] input[type='checkbox']");
    var individuell_no_checked = '';
    
    if(flag == 0){      
      $this.siblings('.error_wrapper').find('.error').text('');
      $activeProduct.find('.individuell-nummer').val(no);
      $activeProduct.find('.individuell-name').val(name);
      $activeProduct.find(".pro_spieler_name").text(name);
      $activeProduct.find(".pro_spieler_no").text(no);
      
      $activeProduct.find('.product-form .properties_flock').val(""+no+" "+name+""); 
      
      individuell_no_checkbox.prop("checked", false);      
      individuell_name_checkbox.prop("checked", false);
      
      
      if($activeProduct.find('.individual_options').length > 0 ){
        let var_id = $activeProduct.find('.individual_options').find('.individual_list li.active').data('variantid');
        if(no){          
           individuell_no_checked = $activeProduct.find(".hidden_product_input[data-content='individuell'] input[type='checkbox'][data-variantid='" + var_id + "']");
           individuell_no_checked.prop("checked", true);
        }
        if(individuell_name_checkbox.length && name){
          individuell_name_checkbox.prop("checked", true);
        }
      }
      else {      
        if(no){
            individuell_no_checkbox.prop("checked", true);
            individuell_no_checked = individuell_no_checkbox;
        }
        if(individuell_name_checkbox.length && name){
          individuell_name_checkbox.prop("checked", true);          
        }      
      }
     
      $activeProduct.find('.spieler-nummer').val('');
      $activeProduct.find(".spieler-name").val('');
      $activeProduct.find('.custom-dropdown-main-wrap .custom-dropdown-list li').removeClass('active'); 
      $activeProduct.find(".product-form__input--dropdown[data-content='spieler'] .select__select").val("0").trigger("change");
      $(settings.objModalCloseBtn).trigger('click');           
       
     const type_price_item =  $activeProduct.find(`.product_trikot_price_wrap .tprice_extra_wrap .hidden-price-item.active[data-type='Flock']`);
     if(type_price_item.length > 0){
       type_price_item.text('');
       type_price_item.attr('data-type','');
       type_price_item.attr('data-amount','');
       type_price_item.removeClass('active');
     }

     applyIndividuellPrice(individuell_name_checkbox, $activeProduct);
     applyIndividuellPrice(individuell_no_checked, $activeProduct);
                 
    }
    else{
      $activeProduct.find('.product-form__error-message-wrapper').removeAttr("hidden");
      $activeProduct.find('.product-form__error-message-wrapper .product-form__error-message').text('Nummer oder Name werden benötigt');
      $activeProduct.find('.product-form .properties_flock').val("");
      const type_price_item =  $activeProduct.find(`.product_trikot_price_wrap .tprice_extra_wrap .hidden-price-item.active[data-type='Flock']`);     
      if(type_price_item.length > 0){
         type_price_item.text('');
         type_price_item.attr('data-type','');
         type_price_item.attr('data-amount','');
         type_price_item.removeClass('active');
       }      
    }
    
    updateTrikotTotal($this);
    
  }     

  subscribe(PUB_SUB_EVENTS.variantChange, (event) => {      
      const $changedEl = $(event.node || event.target);
      updateTrikotTotal($changedEl);  
  });

  function applyIndividuellPrice(checkboxEl, $activeProduct) { 
    if(!checkboxEl){ return; }    
    const pro_tag = checkboxEl.attr("data-tag");
    const pro_type = checkboxEl.attr("data-type");
    const pro_price = checkboxEl.attr("data-price");
    let pro_amount = checkboxEl.attr("data-amount");
    const selected_price_item = $activeProduct.find(
        `.product_trikot_price_wrap .tprice_extra_wrap .hidden-price-item[data-handle='${pro_tag}']`
    ); 
    
    if (checkboxEl.prop("checked")) {      
      if(window.aico_percentage_discount && window.aico_percentage_discount!=0){
          pro_amount = applyAicoDiscount(pro_amount);
      }          
      selected_price_item.text(pro_price);
      selected_price_item.attr("data-type", pro_type);
      selected_price_item.attr("data-amount", pro_amount);
      selected_price_item.addClass("active");
    }
    else {
       selected_price_item.text('');
       selected_price_item.attr('data-type','');
       selected_price_item.attr('data-amount','');
       selected_price_item.removeClass('active');      
    }
  }
  
  function updateTrikotTotal($this){    
     const $activeProduct = $this.closest(".active-product"); 
     const main_price_el = $activeProduct.find(".product_trikot_price_wrap .tprice_main .tprice_main_amount");   
     var main_price = parseFloat(main_price_el.attr('data-amount'));
     var main_og_price = parseFloat(main_price_el.attr('data-main-amount'));
    
     var main_compare_price = parseFloat(main_price_el.attr('data-compare-amount'));
     
     const active_price = $activeProduct.find(".product_trikot_price_wrap .tprice_extra_wrap .hidden-price-item.active");     
     if(active_price.length > 0){
       $activeProduct.find(".product_trikot_price_wrap .gross_price_wrap").removeClass('hide_total');       
     }
     else {
       $activeProduct.find(".product_trikot_price_wrap .gross_price_wrap").addClass('hide_total');
     }

     let total_amount = parseFloat(main_price); 
     let total_og_amount = parseFloat(main_og_price);
     active_price.each(function() {
        let amount = parseFloat($(this).data('amount'));
        let og_amount = parseFloat($(this).data('main-amount'));        
      
        if (!isNaN(amount)) {            
            total_amount += amount;
            total_og_amount += og_amount;
        }
    });
    
    total_amount = total_amount.toFixed(2);    
    total_og_amount = total_og_amount.toFixed(2);

    const total_amount_currency = `${Currency} ${total_amount}`;
    $activeProduct.find(".product_trikot_price_wrap .gross_price_wrap .tprice_total_amount").text(total_amount);
    if(window.aico_percentage_discount && window.aico_percentage_discount!=0){
      $activeProduct.find('.af-discount-price-inner').text(total_amount_currency);
      $activeProduct.find('.price s').text(`CHF ${total_og_amount}`);
    }
    else {
      $activeProduct.find(".price .price__regular .price-item--regular").text(total_amount_currency);
    }
  } 

  $(document).on('click','.active-product .individual_options .individuell-nummer-text',function(){
    $('.active-product .individual_options .individual_list').slideDown();
    $('.active-product .individual_options .individual_list').addClass('open-dropdown');
  });

  $(document).on('click','.product-form__input--dropdown .icon-edit',function(){
     const $activeProduct = $(this).closest(".active-product");
     $activeProduct.find('.spieler_dropdown_wrap .custom-dropdown-options').show();
  });  

  $(document).on('click','.active-product .individual_options .individual_list li',function(){
    const $activeProduct = $(this).closest(".active-product");
    let num_val = $(this).find('span').text();
    let num_sku = $(this).data('variant_sku');
    let variant_id =  $(this).data('variantid');
    $activeProduct.find('.individual_options .individual_list li').removeClass('active');
    $(this).addClass('active');
    $activeProduct.find('.individual_options .individuell-nummer-text').val(num_val);
    $activeProduct.find('.individual_options .individual_list').slideUp();
    $activeProduct.find('.individual_options .individual_list').removeClass('open-dropdown');
    individual_option($(this));
  });

  $(document).on('click','.individual_options .close_icon',function(){
    const $activeProduct = $(this).closest(".active-product");
    $activeProduct.find('.individual_options .individual_list li').removeClass('active');
    $activeProduct.find('.individual_options .individuell-nummer-text').val('');
    $activeProduct.find('.individual_options .individual_list').slideUp();
    $activeProduct.find('.individual_options .individual_list').removeClass('open-dropdown');
    $activeProduct.find(".individuell_fields .individuell-nummer").val('');
    $activeProduct.find(".hidden_product_input[data-content='individuell'] input[type='checkbox']").prop("checked", false);
    const $activeHiddenProduct = $(this).closest(".hidden_product_input");
    individual_option($activeHiddenProduct);    
  });
  
});